import React from 'react';

interface MediaUploadProps {
  label: string;
  imageUrl: string | null;
  handleImageChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleAttachImage: () => Promise<void>;  // Change to async
  handleDeleteImage: () => void;
  summary: string;
}

export const MediaUpload: React.FC<MediaUploadProps> = ({
  label,
  imageUrl,
  handleImageChange,
  handleAttachImage,
  handleDeleteImage,
  summary,
}) => {
  return (
    <div className="browse">
      <label>{label}</label>
      {imageUrl ? (
        <div className="box">
          <img id="imageElement" src={imageUrl} alt={label} />
          <button type="button" onClick={handleDeleteImage} className="ibutton bdelete" title="Delete attachment"></button>
        </div>
      ) : (
        <div className="box">
          <input type="file" onChange={handleImageChange} />
          <button type="button" onClick={handleAttachImage} className="tbutton" title="Upload selected">Attach</button>
          <span>{summary}</span>
        </div>
      )}
    </div>
  );
};

interface ProfileUploadProps {
  imageUrl: string | null;
  handleImageChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleAttachImage: () => Promise<void>;  // Change to async
  handleDeleteImage: () => void;
  summary: string;
}

export const ProfileUpload: React.FC<ProfileUploadProps> = ({
  imageUrl,
  handleImageChange,
  handleAttachImage,
  handleDeleteImage,
  summary,
}) => {
  return (
    <div className="profile-photo">
      {imageUrl ? (
        <div className="box">
          <img id="imageElement" src={imageUrl} />
          <button type="button" onClick={handleDeleteImage} className="ibutton bdelete" title="Delete attachment"></button>
        </div>
      ) : (
        <div className="box">
          <input type="file" onChange={handleImageChange} alt={summary} />
          <button type="button" onClick={handleAttachImage} className="tbutton" title="Upload selected">Attach</button>
        </div>
      )}
    </div>
  );
};
